import { Component, Inject, OnInit } from '@angular/core';
import { AuthService } from './services/auth.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  today: string;
  currentTime: string;
  nom = '';
  prenom = '';
  admin = '';
  accesVueTousUsers = localStorage.getItem("accesVueTousUsers");

  constructor(
    private authService: AuthService
  ) {
    this.authService.accountChange.subscribe(() => this.userChange());

  }

  ngOnInit() {
    const currentDate: Date = new Date();
    const weekday = currentDate.toLocaleDateString('fr-FR', { weekday: 'long' });

    const currentDay = ('0' + currentDate.getDate()).slice(-2);
    // const currentMonth = ('0' + (currentDate.getMonth() + 1)).slice(-2);
    const currentMonth = currentDate.toLocaleDateString('fr-FR', { month: 'long' });

    const currentYear = currentDate.getFullYear();
    this.today = weekday + ' ' +currentDay + ' ' + currentMonth + ' ' + currentYear;
    this.currentTime = currentDate.getHours() + ':' + currentDate.getMinutes();
    

    this.nom = localStorage.getItem("nom");
    this.prenom = localStorage.getItem("prenom");
    this.admin = localStorage.getItem("admin");

  }

  userChange() {
    this.nom = localStorage.getItem("nom");
    this.prenom = localStorage.getItem("prenom");
    this.accesVueTousUsers = localStorage.getItem("accesVueTousUsers");
  }

  logOut() {
    this.authService.logout();
  }




}
